var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 120,
    viewBox: "0 0 100 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3386_49443)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0L100 40V106C100 113.732 93.732 120 86 120H14C6.26801 120 0 113.732 0 106V14C0 6.26801 6.26801 0 14 0H60Z",
    fill: "url(#paint0_linear_3386_49443)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3386_49443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 40H74.7071C66.9751 40 60 33.0249 60 25.2929V0L100 40Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100 40H74.7071C66.9751 40 60 33.0249 60 25.2929V0L100 40Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 90.8213L38.591 72.8606L27.9743 55H36.5178L42.3133 66.4154C42.8458 67.4986 43.2121 68.3068 43.4121 68.8393H43.4872C43.8696 67.9738 44.2698 67.1323 44.6866 66.3159L50.8812 55H58.7254L47.8337 72.7606L59 90.8213H50.6561L43.9613 78.2815C43.6461 77.7485 43.3788 77.1878 43.162 76.6079H43.0625C42.8666 77.1764 42.6071 77.7209 42.2877 78.231L35.3934 90.8213H27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3386_49443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 40H74.7071C66.9751 40 60 33.0249 60 25.2929V0L100 40Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100 40H74.7071C66.9751 40 60 33.0249 60 25.2929V0L100 40Z",
    fill: "#8DD0B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3386_49443",
    x: 58,
    y: -4,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0909637 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3386_49443"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3386_49443",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3386_49443",
    x: 58,
    y: -4,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0909637 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3386_49443"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3386_49443",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3386_49443",
    x1: 50,
    y1: 0.00000120429,
    x2: 90,
    y2: 118.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30AF72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501005,
    stopColor: "#179457"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3386_49443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel_icon.cb4d57fd1f8b8e1d49516cea12566954.svg";
export { ForwardRef as ReactComponent };